import { Patient } from 'gabi-api-ts/v2/patient/query/patient_query';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {PatientChildForm, PatientChildFormSubmitData} from '@/components/business/common/patient/patient-child-form';
import {InfoMessage} from '@/components/form/info-message';
import {PatientRequestService} from '@/services/api-requests/patient-requests-service-ts';

type PatientCreationChildProps = {
    className?: string;
    onCreated: (patient: Patient) => void;
    onChanged: (notSavedDataChild: boolean) => void;
};

function PatientCreationChild(props: PatientCreationChildProps) {
    const { t } = useTranslation();
    const [ loading, setLoading ] = useState(false);

    const handleFormChanged = (notSavedDataChild: boolean) => {
        if(props.onChanged) {
            props.onChanged(notSavedDataChild);
        }
    };

    const createPatientChild = async (newPatient: PatientChildFormSubmitData) => {
        setLoading(true);

        try {
            const newPatientResponse = await PatientRequestService.createPatient(newPatient);
            props.onCreated(newPatientResponse);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className={props.className}>
            <h3>{t('createChild.title')}</h3>

            <InfoMessage infoMessage={t('createChild.info')} text={t('createChild.infoText')} />

            <PatientChildForm
                loading={loading}
                onChanged={handleFormChanged}
                onSubmit={createPatientChild}
            />
        </div>
    );
}

export {PatientCreationChild};

